<template>
  <div>
    <head-nav-bar title="订单详情" :fixed="true" />
    <div class="mt-header-nav confirm-box">
      <cell-box style="padding: 5px 0;" :column="2">
        <cell-item label="联系人：" style="gridColumn:span 2;">
          <div slot="value">
            {{ orderInfo.Contact }}
            <van-tag
              type="danger"
              style="margin-left:10px"
              v-if="orderInfo.Status == 4"
              >{{ orderInfo.StatusName }}</van-tag
            >
            <van-tag
              type="success"
              style="margin-left:10px"
              v-else-if="orderInfo.Status != 0 && orderInfo.Status != 13"
              >{{ orderInfo.StatusName }}</van-tag
            >

            <van-tag color="#f90" style="margin-left:10px" v-else>{{
              orderInfo.StatusName
            }}</van-tag>
          </div>
        </cell-item>
        <cell-item
          label="会员卡："
          v-if="orderInfo.MemberName"
          :value="orderInfo.MemberName"
          style="gridColumn:span 2;"
        />
        <cell-item label="桌台：" :value="tableName" />
        <cell-item label="订单号：" :value="orderInfo.No" />
        <cell-item label="电话：" :value="orderInfo.Phone" />
        <cell-item label="就餐人数：" :value="orderInfo.PersonCount" />
        <cell-item
          label="订餐时间："
          style="gridColumn:span 2;"
          :value="orderInfo.CheckInTime"
          v-if="orderInfo.CheckInTime"
        />
        <cell-item
          label="备注："
          style="gridColumn:span 2;"
          :value="orderInfo.OrderRemark"
          v-if="orderInfo.OrderRemark"
        />
      </cell-box>
      <h3 class="selected-title">
        下单菜品
      </h3>
      <div class="select-foods detail-select-table">
        <template v-for="item in orderFoodList">
          <van-card :key="item.DishId">
            <template #price>
              <div style="color:#555">
                &yen;{{ item.UnitPrice }} x {{ item.Quantity }}
                <van-tag type="success" v-if="item.HadPay">已付款</van-tag>
              </div>
            </template>
            <template #title>
              <div class="food-title">
                <span>
                  {{ item.AccountItemName }}
                  <span
                    v-if="item.PracticeDesc || item.CookingMethodDesc"
                    class="method-txt"
                  >
                    「做法」{{ item.PracticeDesc }}{{ item.CookingMethodDesc }}
                  </span>
                  <span
                    v-if="
                      item.IsUnconfirmed &&
                        orderInfo.Status != 13 &&
                        orderInfo.Status != 0 &&
                        orderInfo.Status != 4
                    "
                    ><van-tag type="danger" mark plain>待确认</van-tag></span
                  >
                </span>
                <span v-if="item.IsPack">
                  <van-tag color="#f60" @click="openPack(item)"
                    >套餐&nbsp;<van-icon
                      :name="
                        openKeys.includes(item.DishId) ||
                        openKeys.includes(item.Id)
                          ? 'arrow-up'
                          : 'arrow-down'
                      "
                  /></van-tag>
                </span>
              </div>
            </template>
            <template #num>
              <span style="color:#f00"> &yen;{{ item.TotalPrice }}</span>
            </template>
            <template v-if="item.IsPack" #footer>
              <ul
                class="pack-detail"
                :class="{
                  'pack-detail-open':
                    openKeys.includes(item.DishId) ||
                    openKeys.includes(item.Id),
                }"
              >
                <li v-for="pack in item.PackDetails" :key="pack.Id">
                  {{ pack.Name }} x {{ pack.Quantity }}
                </li>
              </ul>
            </template>
          </van-card>
        </template>
      </div>
      <van-goods-action>
        <div slot="default" class="summary-info" style="width:100%">
          <span>
            <van-icon name="shopping-cart-o" />总数：<em
              >{{ total.Quantity }}
            </em></span
          >
          <span>
            <van-icon name="balance-o" />总计：<em
              >&yen; {{ total.TotalPrice }}</em
            >
          </span>
        </div>
      </van-goods-action>
    </div>
  </div>
</template>

<script>
import "./rms.less";
import { CellBox, CellItem } from "@/components/cell";
import {
  Cell,
  CellGroup,
  Field,
  Button,
  Card,
  Tag,
  Icon,
  Dialog,
  Toast,
  GoodsAction,
  GoodsActionIcon,
  GoodsActionButton,
} from "vant";
import restaurantApi from "@/api/restaurant.js";
import { accAdd } from "@/utils/common";
export default {
  name: "CreateOrder",
  components: {
    CellBox,
    CellItem,
    [Toast.name]: Toast,
    [Icon.name]: Icon,
    [Tag.name]: Tag,
    [Card.name]: Card,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Field.name]: Field,
    [Button.name]: Button,
    [Dialog.Component.name]: Dialog.Component,
    [GoodsAction.name]: GoodsAction,
    [GoodsActionIcon.name]: GoodsActionIcon,
    [GoodsActionButton.name]: GoodsActionButton,
  },
  data() {
    return {
      orderId: "",
      orderInfo: {},
      orderFoodList: [],
      tableName: "",
      total: {
        Quantity: 0,
        TotalPrice: 0,
      },
      openKeys: [],
    };
  },
  created() {
    this.orderId = this.$route.query.OrderId;
    if (this.orderId) {
      this.getDetail();
    } else {
      Dialog.alert({
        message: "暂无订单！",
        theme: "round-button",
      }).then(() => {
        // on close
      });
    }
  },
  methods: {
    init() {
      let num = 0;
      this.orderFoodList.forEach(item => {
        num = accAdd(num, item.Quantity);
      });
      this.total.Quantity = num;
    },
    getDetail() {
      restaurantApi.getOrderDetail({ Id: this.orderId }).then(res => {
        this.orderInfo = res.Data;
        this.orderFoodList = this.orderInfo.DishTables[0].DishAccounts;
        this.tableName = this.orderInfo.DishTables[0].TableName;
        this.total.TotalPrice = this.orderInfo.TotalAmount;
        this.init();
      });
    },
    openPack(item) {
      let id = item.Id ? item.Id : item.DishId;
      if (this.openKeys.includes(id)) {
        this.openKeys = this.openKeys.filter(el => el != id);
      } else {
        this.openKeys.push(id);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.detail-select-table {
  height: calc(100vh - 250px);
  padding-bottom: 0;
}
</style>
